import react from "react";

const Faq = () => {
    return (
        <>
        <h1>Frequently Asked Questions</h1>
        <h2>Where is the CSS ???</h2>
        <div>There is no CSS.</div>
        </>
    );
}

export default Faq;